import {platform} from 'substance'
import ReadModeCommand from './ReadModeCommand'
import {ReadModeSettings} from "./ReadModeSettings";

const ReadModePackage = {
    name: 'readmode',
    configure: function(configurator) {

        configurator.addCommand('ReadModeCommand', ReadModeCommand)

        if (platform.isMac) {
            configurator.addKeyboardShortcut('cmd+shift+r', {command: 'ReadModeCommand'}, true, 'Activate read mode')
        }
        else {
            configurator.addKeyboardShortcut('ctrl+shift+r', {command: 'ReadModeCommand'}, true, 'Activate read mode')
        }

        configurator.addPluginModule(
            'se.infomaker.readmode.settings',
            ReadModeSettings,
            'se.infomaker.npwriter.settings'
        )

        configurator.addLabel('Read mode', {
            sv: 'Läsläge'
        })

        configurator.addLabel('Activate read mode', {
            sv: 'Aktivera läsläge'
        })

    }
}

export {ReadModePackage}
